import { NgModule } from '@angular/core';
import { DatepickerLibComponent } from './datepicker-lib.component';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap';

@NgModule({
  declarations: [DatepickerLibComponent],
  imports: [
    BrowserModule,
    FormsModule, ReactiveFormsModule,
    BsDatepickerModule
  ],
  exports: [DatepickerLibComponent]
})
export class DatepickerLibModule { }
